/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.LogisticsAttrResponseDto>;
export function request(
  body: defs.basics.LogisticsAttrRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsAttr/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
